import { render, staticRenderFns } from "./OrthoRecurring.vue?vue&type=template&id=0609ac63&scoped=true"
import script from "./OrthoRecurring.vue?vue&type=script&lang=js"
export * from "./OrthoRecurring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0609ac63",
  null
  
)

export default component.exports